/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import lazyLoadView from '@/util/lazyLoadView';

import loadOrderPackageInformationForm from '../../loaders/OrderPackageInformationFormLoader';

import tmplOrderPackageInformationView from './OrderPackageInformationView.hbs';

const OrderPackageInformationView = View.extend({
  template: tmplOrderPackageInformationView,

  className: 'order-package-information-view',

  ui: {
    informationForm: '.information-form'
  },

  regions: {
    informationForm: '@ui.informationForm'
  },

  onRender() {
    const orderPackageID = this.options.orderPackageID;
    const editable = this.options.editable;
    this.informationForm = lazyLoadView(() => loadOrderPackageInformationForm({ orderPackageID, editable }));
    this.showChildView('informationForm', this.informationForm);
  },

  async onSave(e) {
    return await this.informationForm.call('onSave');
  }
});

export default OrderPackageInformationView;
